const MONTHS = ['GEN', 'FEB', 'MAR', 'APR', 'MAG', 'GIU', 'LUG', 'AGO', 'SET', 'OTT', 'NOV', 'DIC'];

export function formatLocalDate(date: string): string {
  const [, month, day] = date.slice(0, 10).split('-').map(Number);
  return `${String(day).padStart(2, '0')} ${MONTHS[month - 1] ?? ''}`;
}

export function formatDayLabel(dayNumber: number) {
  return `DAY ${String(dayNumber).padStart(2, '0')}`;
}

export function formatDeadline(localTimestamp: string) {
  const normalized = localTimestamp.replace(' ', 'T');
  const [date, time = ''] = normalized.split('T');
  return {
    date: formatLocalDate(date),
    time: time.slice(0, 5)
  };
}

export function statusLabel(status: string) {
  return status.replaceAll('_', ' ');
}
